import { useQuery } from '@tanstack/react-query';
import { getManagementUserPromise } from 'src/utils';
import { QUERY_KEY_MAP } from 'src/constants';

export const useGetManagementUser = (userId?: string) => {
  const { data, isLoading, error, isRefetching } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetManagementUser, userId],
    queryFn: () => getManagementUserPromise(userId as string),
    enabled: !!userId,
  });

  return {
    data,
    isLoading,
    error,
    isRefetching,
  };
};
